import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { Permissions } from "permissions";
import { RouteDescription } from "types";

const FileRequestsPage = lazy(() => import("./FileRequestsPage"));

export const fileRequestsRoutes: RouteDescription[] = [
  {
    path: links.fileRequests,
    element: withPageLoader(<FileRequestsPage />),
    breadcrumb: "Send requests",
    menuItem: {
      id: "fileRequests",
      label: "File requests",
    },
    requiredOneOfPermissions: [ Permissions.Admin, Permissions.SuperAdmin, Permissions.Compliance ],
  },
];